module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('h4', [_vm._v("Buscar datos")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.processForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-required": "true",
      "name": "search-input",
      "placeholder": "Palabra clave"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "accordion fancy radius clean"
  }, _vm._l((_vm.sections), function(section) {
    return _c('nav-item', {
      key: section.title,
      attrs: {
        "slug": section.slug,
        "title": section.title,
        "icon": section.icon,
        "categories": section.topics
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "widget-subscribe-submit-button"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b1302c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 57
// module chunks = 1